import { STATES, ITEM_KINDS } from '../../../constants';

export function UpdateAccountsConfig($stateProvider) {
  'ngInject';
  $stateProvider.state(STATES.STEP_UPDATE_ACCOUNTS, {
    url: '/update-accounts',
    views: {
      '@': {
        template: '<upd-update-accounts></upd-update-accounts>',
      },
    },
    params: {
      // Pass in `verified` in the $stateParams to show success message
      verified: undefined,
    },
    reloadOnSearch: false,
    scrollTop: true,
    title: 'Update Your Accounts',
    titleBar: {
      title: 'Update Your Accounts',
      icon: 'accounts',
      save: 'Average Time Saved: 3 Hours',
    },
    analytics: {
      page: 'Update Accounts',
    },
    data: {
      permissions: 'signedIn && moveConfirmed && !needToVerify',
      confirmState: STATES.STEP_UPDATE_ACCOUNTS_CONFIRM,
      verifyState: STATES.STEP_UPDATE_ACCOUNTS_VERIFY,
      moveItem: {
        type: ITEM_KINDS.UPDATE_ACCOUNT,
        // Determines whether or not there can be more than 1 of these move items
        singleton: false,
      },
    },
  });
}
